import { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';

interface EmailPreviewProps {
  className?: string;
  html?: string;
  subject?: string;
  isReadOnly?: boolean;
}

export const EmailPreview = ({
  className,
  subject = 'Subject',
  html = '',
  isReadOnly = true,
}: EmailPreviewProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const adjustIFrameHeight = () => {
      const iframe = iframeRef.current;
      if (iframe && iframe.contentDocument && iframe.contentDocument.body) {
        const contentHeight = iframe.contentDocument.body.scrollHeight;
        iframe.style.height = `${contentHeight}px`;
      }
    };

    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('load', adjustIFrameHeight);
      adjustIFrameHeight();
      setTimeout(adjustIFrameHeight, 100);
    }

    return () => {
      if (iframe) iframe.removeEventListener('load', adjustIFrameHeight);
    };
  }, [html]);

  return (
    <Stack
      className={className}
      sx={{
        gap: sp[16],
        border: '1px solid #d9d9d9',
        p: sp[24],
        borderRadius: '16px',
        background: '#ffffff',
        minHeight: 'min-content',
        ...(isReadOnly && { pointerEvents: 'none' }),
      }}
    >
      <Box sx={{ typography: 'bodyMediumWeight', color: '#000000' }}>
        {subject}
      </Box>
      <Box
        component='iframe'
        scrolling='no'
        srcDoc={html}
        ref={iframeRef}
        sx={{ display: 'block', height: '100%', border: 0, m: 0 }}
      />
    </Stack>
  );
};

EmailPreview.displayName = 'EmailPreview';

export default EmailPreview;
